const acelerador = angular.module('acelerador', [])

acelerador.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.acelerador',
            url: '/acelerador',
            params: { showGlobalLoading: { dynamic: true, value: true }},
            component: 'acelerador.aceleradorComponent'
        },
        {
            name: 'cliente.aceleradorDetalhe',
            url: '/acelerador/:idFaq/artigo/:idArtigo',
            params: { showGlobalLoading: { dynamic: true, value: true }, idFaq: null, idArtigo: null },
            component: 'acelerador.aceleradorDetalheComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);